import { render, staticRenderFns } from "./HandlerPool.vue?vue&type=template&id=0c2a55eb&scoped=true"
import script from "./HandlerPool.vue?vue&type=script&lang=js"
export * from "./HandlerPool.vue?vue&type=script&lang=js"
import style0 from "./HandlerPool.vue?vue&type=style&index=0&id=0c2a55eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a55eb",
  null
  
)

export default component.exports